import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, SparklesIcon } from 'lucide-react';
const achievements = [{
  title: '1. Identificarás Tus Bloqueos Inconscientes Por Primera Vez',
  desc1: 'Realizarás un autodiagnóstico profundo para descubrir las frases y creencias que escuchaste en tu infancia y que hoy frenan tu crecimiento sin que te des cuenta.',
  desc2: 'Sabrás exactamente cuál es tu saboteador principal y cómo opera en tu vida financiera real.'
}, {
  title: '2. Reprogramarás Tu Mente Con Base En Neurociencia Real',
  desc1: 'Aprenderás el Ciclo Poderoso de la Manifestación: cómo tus pensamientos generan reacciones bioquímicas que crean conexiones neuronales nuevas.',
  desc2: 'Instalarás creencias de abundancia de forma científica, no con afirmaciones genéricas que tu mente rechaza, sino con el método de Afirmaciones de Puente que tu subconsciente sí acepta.'
}, {
  title: '3. Convertirás El Fracaso En Tu Mayor Activo',
  desc1: 'Obtendrás herramientas concretas para diferenciar el fracaso temporal del definitivo.',
  desc2: 'Transformarás cada momento de frustración en un escalón hacia la oportunidad, y nunca más abandonarás una meta justo antes de cruzar el umbral del éxito.'
}, {
  title: '4. Vivirás En Mentalidad de Abundancia Antes de Ver Los Resultados',
  desc1: 'El sistema fusiona principios de riqueza clásica con fe genuina. Aprenderás a alinear tus pensamientos, emociones y acciones con tus metas financieras usando el Sistema de Visualización Neuro-Espiritual de 7 minutos diarios.',
  desc2: null
}, {
  title: '5. Tendrás Una Estructura Financiera Clara y Funcionando',
  desc1: 'No se queda solo en la mente. Tendrás el Método 70/30 aplicado a tus ingresos reales, con plantillas simples para medir lo que entra y lo que sale, sin importar cuánto ganes hoy.',
  desc2: null
}, {
  title: '6. Tomarás Decisiones Financieras Con Claridad',
  desc1: 'Aprenderás a evaluar deudas e inversiones con criterios claros. Sabrás exactamente qué deudas eliminar primero, qué gastos optimizar y qué activos priorizar para que tu dinero trabaje para ti.',
  desc2: null
}, {
  title: '7. Tendrás Un Plan Real a 30, 90 y 365 Días',
  desc1: 'El sistema culmina con una Hoja de Ruta Maestra personalizada con metas medibles y la Fórmula 70/30 activa.',
  desc2: 'Pasarás de la teoría a la ejecución real. Y en 365 días tendrás una vida financiera que hoy parece imposible.'
}];
export function AchievementsSection() {
  return <section className="py-12 md:py-16 px-4 md:px-8 bg-navy-midnight" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16" data-id="element-3">
          <h3 className="text-3xl md:text-5xl font-headline font-extrabold text-white mb-6" data-id="element-4">
            Esto No Es Un Simple Ebook Financiero.
          </h3>
          <p className="text-lg text-body font-body" data-id="element-5">
            Es una guía integral que une espiritualidad, neurociencia y
            organización práctica. Al aplicar sus 7 pasos, esto es exactamente
            lo que vas a lograr:
          </p>
        </motion.div>

        <div className="space-y-8 mb-16" data-id="element-6">
          {achievements.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-dark rounded-2xl p-6 md:p-8 border border-gold-separator/20 hover:border-gold/50 transition-colors shadow-soft" data-id="element-7">
              <div className="flex items-start gap-4" data-id="element-8">
                <CheckCircleIcon className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-9" />
                <div data-id="element-10">
                  <h4 className="text-xl md:text-2xl font-headline font-bold text-white mb-4" data-id="element-11">
                    {item.title}
                  </h4>
                  <div className="space-y-3 text-body font-body" data-id="element-12">
                    <p data-id="element-13">{item.desc1}</p>
                    {item.desc2 && <p data-id="element-14">{item.desc2}</p>}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-hero border border-gold rounded-2xl p-8 md:p-12 text-center relative overflow-hidden shadow-gold" data-id="element-15">
          <SparklesIcon className="absolute top-4 right-4 w-12 h-12 text-gold/20" data-id="element-16" />
          <SparklesIcon className="absolute bottom-4 left-4 w-8 h-8 text-gold/20" data-id="element-17" />

          <h4 className="text-2xl md:text-3xl font-headline font-bold text-gold mb-6 flex items-center justify-center gap-3" data-id="element-18">
            ✨ Y Además Activarás Una Mentalidad de Abundancia
          </h4>
          <p className="text-lg md:text-xl text-white italic font-serif max-w-2xl mx-auto" data-id="element-19">
            Antes de tener el dinero. Para atraer oportunidades con una nueva
            vibración energética y espiritual que ya operará en ti desde el
            primer día.
          </p>
        </motion.div>
      </div>
    </section>;
}